import { PrimaryButton } from "@fluentui/react/lib/Button";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { WithTranslator } from "../Translator";
import { IBaseDialogProps } from "./IBaseDialogProps";

export const BaseDialog = WithTranslator((props: IBaseDialogProps): JSX.Element => {
  const {
    children,
    dialogContentProps = {},
    dialogProps = {},
    isOpen,
    modalProps = {},
    onDismiss,
    showCloseButton,
    title,
    translator
  } = props;

  return (
    <Dialog
      dialogContentProps={{
        title,
        type: DialogType.largeHeader,
        ...dialogContentProps
      }}
      hidden={!isOpen}
      modalProps={{ ...modalProps }}
      onDismiss={onDismiss}
      styles={{ main: { width: `480px !important`, maxWidth: `480px !important` } }}
      {...dialogProps}
    >
      {children}
      {showCloseButton && (
        <DialogFooter>
          <PrimaryButton onClick={onDismiss} text={translator.get(`generic.close`, `Close`)} />
        </DialogFooter>
      )}
    </Dialog>
  );
});
